<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">  
    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="editRecord()"
    />
    <!-- <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" /> -->
  </div>
</template>

<script>
export default {
  name: "CellRendererEditGroup",
  methods: {
    editRecord() {      
        this.$root.$emit("openMappingPopUp", this.params.group);
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete "${this.params.group.GroupName}"`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      });
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      //this.showDeleteSuccess();
      this.$vs.loading();
      /* UnComment below lines for enabling true flow if deleting user */
     this.$store.dispatch("agendaManagement/removeGroupMapping", [{GroupId:this.params.group.GroupId,GroupName:this.params.group.GroupName}])
        .then(()   => { 
          this.$vs.loading.close();
          this.showDeleteSuccess() 
        })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        //title: "User Deleted",
        text: "The selected group was successfully deleted"
      });
    },
    showChangeStatusSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Status Changed",
        text: "Status changed successfully"
      });
    }
  }
};
</script>
